module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0005.39ed1e11.jpg";